import { render, staticRenderFns } from "./WhyNozax.vue?vue&type=template&id=098415db&scoped=true&"
import script from "./WhyNozax.vue?vue&type=script&lang=js&"
export * from "./WhyNozax.vue?vue&type=script&lang=js&"
import style0 from "./WhyNozax.vue?vue&type=style&index=0&id=098415db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098415db",
  null
  
)

export default component.exports